<nav
  class="app-sidebar"
  myAutoCloseMobileNav
  [ngClass]="{
    'bg-color-light': ['31', '32', '33', '34', '35', '36'].indexOf(AppConfig.colorOption) >= 0,
    'bg-color-dark': ['31', '32', '33', '34', '35', '36'].indexOf(AppConfig.colorOption) < 0,
  }"
>
  <section class="sidebar-header" [style.background-color]="color | async">
    <!-- <span class="logo-icon material-icons">view_compact</span> -->
    <svg
      class="logo-img"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 277.64 336.19"
      xml:space="preserve"
      [style.fill]="textColor | async"
    >
      <defs></defs>
      <path class="a" d="M147,30.26V55.8c0,14.68-4.07,20.11-32.51,14L0.22,44.37V0Z" />
      <path
        class="a"
        d="M270.21,146.84v85c0,73.34-39.37,104.36-110.4,104.36C79.52,336.19,0,298.61,0,197.86V121.69ZM42.46,193.93c1.09,78.23,71.27,83.64,119.91,83.64,37.06,0,63.21-19.32,64.61-48.89V187.42L42.46,172.56v21.37Z"
      />
      <path
        class="a"
        d="M233.19,21.68c25.32,0,44.45,21.94,44.45,46.7s-19.13,42.2-41.63,42.2c-25.88,0-44.45-22.5-44.45-47.26S210.13,21.68,233.19,21.68Z"
      />
    </svg>
    <!--<a [routerLink]="['/']" class="brand" [style.color]="textColor | async">{{AppConfig.brand}}</a>-->
    <a [routerLink]="['/']" class="brand" [style.color]="textColor | async">{{
      siteTitle | async
    }}</a>
    <a href="javascript:;" class="collapsednav-toggler" (click)="toggleCollapsedNav()">
      @if (this.AppConfig.navCollapsed) {
        <i class="material-icons">radio_button_unchecked</i>
      }
      @if (!this.AppConfig.navCollapsed) {
        <i class="material-icons">radio_button_checked</i>
      }
    </a>
  </section>

  <section class="sidebar-content">
    <ul class="nav" myAccordionNav myHighlightActiveItems>
      @for (value of navBarConfigs_Main | async; track value) {
        <li>
          <a
            mat-button
            (click)="openNavBarItem(value, $event)"
            [matBadge]="formatNumber(value.count | async) | async"
            [matBadgeHidden]="(value.count | async) == null"
          >
            <i class="nav-icon material-icons">{{ value.icon }}</i>
            <span class="nav-text">{{ value.displayname }}</span>
          </a>
          @if (value.items != null) {
            <ul>
              @for (item of value.items; track item) {
                <li>
                  <a
                    mat-button
                    (click)="openNavBarItem(item, $event)"
                    [matBadge]="formatNumber(item.count | async) | async"
                    [matBadgeHidden]="(item.count | async) == null"
                  >
                    <i class="material-icons">keyboard_arrow_right</i>
                    <span>{{ item.displayname }}</span>
                  </a>
                </li>
              }
            </ul>
          }
          @if (value.items != null) {
            <i class="material-icons icon-has-ul">arrow_drop_down</i>
          }
        </li>
      }
    </ul>
  </section>

  <section class="sidebar-footer">
    <ul class="nav">
      @for (value of navBarConfigs_Footer | async; track value) {
        <li>
          <a
            mat-button
            (click)="openNavBarItem(value, $event)"
            [matBadge]="formatNumber(value.count | async) | async"
            [matBadgeHidden]="(value.count | async) == null"
          >
            <i class="nav-icon material-icons">{{ value.icon }}</i>
            <span class="nav-text">{{ value.displayname }}</span>
          </a>
          @if (value.items != null) {
            <ul>
              @for (item of value.items; track item) {
                <li>
                  <a
                    mat-button
                    (click)="openNavBarItem(item, $event)"
                    [matBadge]="formatNumber(item.count | async) | async"
                    [matBadgeHidden]="(item.count | async) == null"
                  >
                    <i class="material-icons">keyboard_arrow_right</i>
                    <span>{{ item.displayname }}</span>
                  </a>
                </li>
              }
            </ul>
          }
          @if (value.items != null) {
            <i class="material-icons icon-has-ul">arrow_drop_down</i>
          }
        </li>
      }
    </ul>
  </section>
</nav>
